<template>
  <div class="bg">
    <div class="caption">
      <img src="@/assets/images/caption_underline_green.png" />
      <div class="caption_text">{{ label }}</div>
    </div>
  </div>
</template>
    
    <script>
export default {
  props: ["label"],
  data() {
    return {};
  },
};
</script>
    
  <style scoped>
  .bg {
    display: flex;
    justify-content: center;
    text-align: center;
  }
.caption {
  width: fit-content;
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
}

.caption_text {
  font-size: 24px;
  font-weight: 700;
  color: #00B8BD;
}

.caption img {
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
}
</style>